import styled from 'styled-components';

export const Holder = styled.div`
  margin: auto;
  position: relative;
  max-width: 1280px;
  width: 100%;

  img.tick {
    position: absolute;
    opacity: 0;
  }
`;

export const Container = styled.div`
  color: #00b261;
  font-family: 'Work Sans', sans-serif;
  margin: auto;
  max-width: 1280px;
  max-height: none;
  position: relative;
  z-index: 99;
  width: 100%;

  &:before {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }

  @media screen and (orientation: portrait) {
    /* max-height: 0' */
  }

  h1 {
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Video = styled.div`
  left: 0;
  opacity: ${props => (props.showing ? 1 : 0)};
  position: absolute;
  top: 0;
  width: 100%;

  .video {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const Tickbox = styled.button`
  background-color: transparent;
  border: 1px solid rgba(230, 230, 230, 0);
  cursor: pointer;
  height: ${props => props.h};
  left: ${props => props.x};
  outline: none;
  position: absolute;
  top: ${props => props.y};
  transform: rotate(${props => props.angle});
  transition: all 0.3s ease;
  width: ${props => props.w};

  &:hover,
  &:active {
    &:before {
      content: '';
      background-image: url('img/tick.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100%;
      display: block;
      height: 50%;
      position: absolute;
      left: ${props => props.tickX};
      top: ${props => props.tickY};
      width: 5%;
    }
  }
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: block;
  height: 86px;
  margin: 0 auto 32px;
  width: 60px;

  @media (min-width: 375px) {
    width: 75px;
  }
`;

export const Overlay = styled.div`
  background-color: rgba(38, 38, 38, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  @media (min-width: 1024px) {
    justify-content: flex-end;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    margin: 16px auto 8px;
    text-align: center;
    width: 90%;

    @media (min-width: 1024px) {
      margin: 0 auto 25px;
      font-size: 24px;
      max-width: 750px;
    }
  }
`;

export const ShareContainer = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;

  margin-bottom: 16px;
  align-items: center;
  h3 {
    color: #00b261;
    font-size: 24px;
    font-weight: 500;

    @media (min-width: 1024px) {
      position: relative;
      bottom: auto;
    }
  }

  & > div {
    margin: 0 8px;
  }

  @media (min-width: 1024px) {
    position: relative;
  }
`;

export const Footer = styled.div`
  align-items: center;
  padding: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  @media only screen and (orientation: landscape) {
    display: none;
  }

  @media (min-width: 1024px) {
    align-items: center;
    position: relative;
    display: flex;
    flex-direction: row;
    height: auto;
    justify-content: space-between;
  }

  .title {
  }

  h1 {
    color: #00b261;
    font-size: 32px;
    font-weight: 900;
    margin: 16px auto 0;
    text-align: center;

    @media (min-width: 1024px) {
      margin: 12px auto 0;
      font-size: 72px;
    }
  }

  p {
    color: #00b261;
    font-size: 32px;
    text-align: center;
    padding-bottom: 40px;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  img.yourself {
    display: block;
    width: 80px;
    margin: -16px auto 20px;

    @media (min-width: 1024px) {
      width: 200px;
      margin: -32px auto 40px;
    }
  }

  img.rotate {
    width: 70px;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  img.pdp-logo {
    position: absolute;
    bottom: -75px;
    top: auto;
    width: 80px;

    @media (min-width: 1024px) {
      position: relative;
      bottom: auto;
      width: 150px;
    }
  }
`;

export const Message = styled.div`
  background-color: #ffffff;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  @media screen and (orientation: portrait) {
  }

  @media screen and (orientation: landscape) {
    display: none;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;
